import { CustomIconProps } from 'assets/ShareIcons/ShareIcon';

const LeftArrow: React.FC<CustomIconProps> = () => {
  return (
    <svg
      width='22'
      height='48'
      viewBox='0 0 22 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.5 44.4883L18.5 24.4883L3.5 4.48828'
        stroke='white'
        stroke-width='5'
        stroke-linecap='square'
      />
    </svg>
  );
};

export default LeftArrow;
